import React from 'react';
import Styles from './circle-loader-styles.scss';
const CircleLoader = () => {
    return (React.createElement("div", { className: Styles.loader },
        React.createElement("div", { className: Styles.circle }),
        React.createElement("div", { className: Styles.circle }),
        React.createElement("div", { className: Styles.circle }),
        React.createElement("div", { className: Styles.circle }),
        React.createElement("div", { className: Styles.circle }),
        React.createElement("div", { className: Styles.circle }),
        React.createElement("div", { className: Styles.circle }),
        React.createElement("div", { className: Styles.circle })));
};
export default CircleLoader;
